<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="app">
		<router-view v-bind:sidebarItems="sidebarItems" :key="$route.fullPath"></router-view>
	</div>
</template>

<script>
import themeConfig from '@/../themeConfig.js';
import axios from 'axios';  

export default {
    data() {
        return {
            sidebarItems: [],

        }
    },
    watch: {
        '$store.state.theme'(val) {
            this.toggleClassInBody(val);
        },
        '$route' (new_val, old_val) {
            const time_limit = 1000 * 60 * 60 * 2;
            const currentTime = new Date().getTime();

            if(old_val.name == 'pageLogin'){
                this.getSideBarItems();
            }

            if(!this.$route.meta.public && this.$user !== null && currentTime - this.$user.time > time_limit) {
                this.logout();
            }
            this.checkVersion();
        },
        $user:{
            handler: function(new_val, old_val) {
                this.getSideBarItems();
            },
            deep: true,
        } 
    },
    methods: {
        getSideBarItems: function() {

            this.sidebarItems = [];
            if(this.isLoggedIn()) {
                let sideBarsItems_tmp = require('@/layouts/components/vx-sidebar/sideBarsItems/items_' +this.$user.role+ '.js')['default'];
                for(let i = 0; i < sideBarsItems_tmp.length; i++) {
                    if(typeof sideBarsItems_tmp[i].needs_rsv === 'undefined' || !sideBarsItems_tmp[i].needs_rsv) {
                        if(typeof sideBarsItems_tmp[i].user_type === 'undefined' || !sideBarsItems_tmp[i].user_type) {
                            this.sidebarItems.push(sideBarsItems_tmp[i]);
                        }else if(sideBarsItems_tmp[i].user_type === 'staff' && this.$user.is_staff){
                            this.sidebarItems.push(sideBarsItems_tmp[i]);
                        }
                    }
                    else if(Object.keys(this.$user.hotel).length > 0) {
                        if(typeof sideBarsItems_tmp[i].rsv_status !== 'undefined'
                            && sideBarsItems_tmp[i].needs_rsv
                            && sideBarsItems_tmp[i].rsv_status.indexOf(parseInt(this.$user.hotel.cod_rsv_status)) !== -1
                        ) {
                            //OLD MECHANIC OF SHUTDOWN BY HOTEL
                            //if(typeof sideBarsItems_tmp[i].hotel_ids === 'undefined') {
                                //this.sidebarItems.push(sideBarsItems_tmp[i]);
                            //}
                            //else if(sideBarsItems_tmp[i].hotel_ids.indexOf(parseInt(this.$user.hotel.hotel_id)) !== -1) {
                                this.sidebarItems.push(sideBarsItems_tmp[i]);
                            //}
                        }
                    }
                }
            }
        },
        checkVersion: function() {
            axios({
                method: 'get',
                url: '/version.txt?_=' +new Date().getTime(),
            })
            .then(function (resp) {
                if(localStorage.getItem('version') != resp.data) {
                    localStorage.setItem('version', resp.data);
                    window.location.reload(true);
                }
            })
            .catch( function (err) {
                console.log('error getting version');
            });
        },
        toggleClassInBody(className) {
            if (className == 'dark') {
                if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
                document.body.classList.add('theme-dark');
            } else if (className == 'semi-dark') {
                if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
                document.body.classList.add('theme-semi-dark');
            } else {
                if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
                if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
            }
        }
    },
    mounted() {
        this.toggleClassInBody(themeConfig.theme);
        this.$i18n.locale = !window.localStorage.getItem('locale') ? 'pt' : window.localStorage.getItem('locale');
    },
    created: function() {
        this.$user = JSON.parse(localStorage.getItem('userSession'));
        this.getSideBarItems();
    }
}
</script>
<style>
    @import '../node_modules/vue-select/dist/vue-select.css';
    .vue-select .vs__search::placeholder,
    .vue-select .vs__dropdown-toggle,
    .vue-select .vs__dropdown-menu {
        background-color: #ffffff;
        color: #394066;
    }
    .vs__dropdown-menu {
        z-index: 99999;
    }
    .vs-popup--background {
        background: rgba(0,0,0, .7) !important;
    }
    .vs-notifications h3{
        padding: 0 !important;
    }

    /* Calendar - Overriding the plugins original CSS*/
    .vdp-datepicker__calendar{
        bottom: 38px;
    }
    .vdp-datepicker__calendar .cell.selected {
        background: #63C0BB !important;
    }   
    .vdp-datepicker__calendar .cell:hover, .vdp-datepicker__calendar .cell.selected:hover {
        background: #63C0BB;
    }
    .vdp-datepicker__calendar header span {
        color: #63C0BB;
    }
    .vdp-datepicker input{
        width: 300px;
        padding: .7rem;;
    }
    /* Calendar - Stop Overriding the plugin original CSS*/


    
    .ql-editor {
        font-family: "Montserrat";
    }

    .ql-font-arial {
        font-family: "Arial" !important;
    }
    .ql-font-comicsans {
        font-family: "Comic Sans MS", cursive !important;
    }
    .ql-font-inconsolata {
        font-family: "Inconsolata" !important;
    }
    .ql-font-montserrat {
        font-family: "Montserrat" !important;
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value='arial']::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='arial']::before
    {
        content: 'Arial' !important;
        font-family: 'Arial' !important;
    }
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value='comicsans']::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='comicsans']::before
    {
        content: 'Comic Sans' !important;
        font-family: "Comic Sans MS", cursive !important;
    }
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value='inconsolata']::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='inconsolata']::before
    {
        content: 'Inconsolata' !important;
        font-family: 'Inconsolata' !important;
    }
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value='montserrat']::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='montserrat']::before
    {
        content: 'Montserrat' !important;
        font-family: 'Montserrat' !important;
    }


    .color-primary {
        color: #63C0BB;
    }
    @media only screen and (max-width: 400px) {
        .mainForm .vdp-datepicker input{
            width: 270px !important;
        }
    }
    .vdp-datepicker input{
        width: 300px;
        padding: .7rem;;
    }
    /* Calendar - Stop Overriding the plugin original CSS*/

    .cv-header-day{
        text-transform: capitalize;
    }

    .mainForm .ql-editor {
        height: 150px !important;
    }
    .mainForm .editorSpace{
        margin-bottom: 10px !important;
    }

    
    .capitalize{
        text-transform: capitalize;
    }
</style>